import React from 'react';
import './PlayerList.css';
import { useGame } from '../../contexts/GameContext';

const PlayerList = () => {
  const { lobby, playerId, isHost } = useGame();
  
  if (!lobby || !lobby.players) {
    return <div className="player-list-empty">Bekleyen oyuncu yok</div>;
  }
  
  return (
    <div className="player-list-container">
      <h2 className="player-list-title">Oyuncular ({lobby.players.length})</h2>
      <ul className="player-list">
        {lobby.players.map((player) => (
          <li 
            key={player.id} 
            className={`player-item ${player.id === playerId ? 'player-item--current' : ''}`}
          >
            <div className="player-item__name">
              {player.name}
              {player.id === lobby.hostId && (
                <span className="player-item__badge">Kurucu</span>
              )}
              {player.id === playerId && (
                <span className="player-item__badge player-item__badge--self">Sen</span>
              )}
            </div>
            {lobby.gameStarted && player.isReady && (
              <div className="player-item__status player-item__status--ready">
                Hazır
              </div>
            )}
            {lobby.gameStarted && player.isSilenced && (
              <div className="player-item__status player-item__status--silenced">
                Susturuldu
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PlayerList;
